import React, { useState } from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { sanitizeUrl } from 'pubweb-smokey/dist/utils/utils';
import PostCard from '../Contentful/PostCard/PostCard';
import PostsDeckStyles from './PostsDeck.styled';
import { categoryName } from '@utils/studioUtils';
import Button from '@components/Shared/Buttons/Button';
import { formatHttpsUrl } from '@utils/utils';

const PostsDeck = ({
  headline,
  posts = [],
  loadMore = false,
  showFirstLarge = false,
  postsDisplayed = 16,
  className = '',
}) => {
  const [totalPosts] = useState(posts);
  const [loadedPosts, setLoadedPosts] = useState(
    posts && loadMore ? posts.slice(0, postsDisplayed) : posts
  );
  const [numberOfPostsPerLoad] = useState(postsDisplayed);
  const [numberOfPostsDisplayed, setNumberOfPostsDisplayed] =
    useState(postsDisplayed);
  const [showLoadMore, setShowLoadMore] = useState(
    loadMore && postsDisplayed < posts.length
  );

  const handleLoadMore = (ev) => {
    ev.preventDefault();

    let numberOfPosts = numberOfPostsDisplayed + numberOfPostsPerLoad;
    setNumberOfPostsDisplayed(numberOfPosts);
    setLoadedPosts(totalPosts.slice(0, numberOfPosts));
    setShowLoadMore(numberOfPosts < totalPosts.length);
  };

  let postsFormatted = loadedPosts
    ? loadedPosts.map(
        ({ headline, postSubcategory, tag, featuredMedia, slug }, i) => {
          const firstImage = showFirstLarge && i === 0;
          const imageHeight = firstImage ? 423 : 160;
          const postImageURL =
            featuredMedia &&
            featuredMedia.media &&
            featuredMedia.media.file &&
            featuredMedia.media.file.url
              ? featuredMedia.media.file.url + `?h=${imageHeight}&fm=webp`
              : null;
          const title = headline ? headline : null;
          const category = categoryName(postSubcategory);

          return (
            <div key={`post-card-${slug}-${i}`} className="post-card-container">
              <Link href={`/studio/${sanitizeUrl(slug)}`}>
                <PostCard
                  largeCard={firstImage}
                  image={formatHttpsUrl(postImageURL)}
                  imageAltText={
                    featuredMedia && featuredMedia.altText
                      ? featuredMedia.altText
                      : null
                  }
                  category={category}
                  tag={tag ? tag : null}
                  title={title}
                />
              </Link>
            </div>
          );
        }
      )
    : null;

  //If we are showing the first card as a "large" card, let's format the flex boxes slightly differently for desktop.
  if (showFirstLarge) {
    let firstPost = postsFormatted[0]; // eslint-disable-line prefer-destructuring
    let remainingPosts = postsFormatted.slice(1);

    postsFormatted = (
      <div className="large-card-format">
        <div className="first-card">{firstPost}</div>
        <div className="remaining-cards">{remainingPosts}</div>
      </div>
    );
  }

  return (
    <PostsDeckStyles className={className}>
      <div className="main-heading">
        <div className="h4">{headline}</div>
      </div>

      <div className="post-cards post-cards-small">{postsFormatted}</div>

      {showLoadMore && (
        <div className="load-more">
          <Button
            isCompact={true}
            buttonStyle="outlined"
            onClick={(ev) => handleLoadMore(ev)}
          >
            Load More
          </Button>
        </div>
      )}
    </PostsDeckStyles>
  );
};

PostsDeck.propTypes = {
  className: PropTypes.string,
  headline: PropTypes.string,
  loadMore: PropTypes.bool,
  posts: PropTypes.array,
  postsDisplayed: PropTypes.number,
  showFirstLarge: PropTypes.bool,
};

export default PostsDeck;
